import { useNotionDatabase } from "dev";

import Router from "@/src/components/router";

export default function Index() {
  const db = useNotionDatabase("0b0316fe7db7485ebb76c00db50cd0b5");

  if (!db) return <span>no db</span>;

  const data = db.map((r) => ({
    text: `${r["Name"]}, [${r["Delivery type"]}], ${r["Types"]}` || "",
    uuid: r["uuid"],
    userId: r["userId"],
  }));

  return (
    <Router
      routes={data.map((r) => ({
        text: r.text,
        componentUrl: `/merchant/product-form/${r.uuid}?userId=${r.userId}`,
      }))}
    />
  );
}
